<template>
	<v-col class="heading-6 ml-4">
		Sorry, we couldn't find page.
		<div class="mt-5">
			<a href="/" class="text-decoration-none font-under-normal mr-1">
				Go to the Dashboard
			</a>
			instead?
		</div>
	</v-col>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: 'Not found',

	data: () => ({
		sheet: false,
	}),

	methods: {
		...mapMutations([]),
	},

	mounted() {},

	computed: {
		...mapGetters(['theme']),
	},
}
</script>

<style scoped>
::-webkit-scrollbar {
	width: 0px;
	background: transparent;
}
</style>
